<template>
    <div class="panel-body">
     <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRetirar="opcionRetirar" :opcionGestionar="opcionGestionar"  :requiereGestionar="requiereGestionar"
         :titulomodal="titulomodal" :botonmodal="botonmodal" :requiereBotongestionar="requiereBotongestionar" 
         :opcionRechazar="opcionRechazar" :condicionales="condicionales" :carpeta="carpeta" :opcionAsignar="opcionAsignar"
          :typeOrder="typeOrder" :rechazadaXProveedor="rechazadaXProveedor" :proveerdor="proveerdor" :opcionDividir="opcionDividir"></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            rechazadaXProveedor:false,
            typeOrder: "desc",
            carpeta:"Prestadores",
             vista:"Recepción de solicitudes",
             proveniente:" - Recepción de solicitudes",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"en solicitud",
             editable:1,
             cliente:1,
             proveerdor:1,
             requiereGestionar:false,
             opcionAsignar:true,
             opcionRetirar:false,
             opcionRechazar:true,
             opcionGestionar:false,
             opcionDividir:true,
             titulomodal:"Gestión y seguimiento",
             botonmodal:"Aceptar",
             requiereBotongestionar:"no",
             options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' }, { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'departamento', text: 'Departamento' }],
             
             departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsclientes: [
                { value: null, text: 'Seleccionar' },
                { value: 1, text: 'cliente1' },
                { value: 2, text: 'clientes2' }
            ],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            optionss: [
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '17', text: 'Dividida' },
                { value: '11', text: 'Cancelado' },


            ],
            optionm:[{ value: null, text: 'Seleccionar' },
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '17', text: 'Dividida' },
                { value: '11', text: 'Cancelado' },
             ],
            endDate: "",
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Solicitante', sortable: true },
                { key: 'F.Solicitud', sortable: true }, 
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                 { key: 'Paciente', sortable: true },
                 { key: 'Estado', sortable: true },
                 { key: 'Departamento', sortable: true },
                 {key: 'Ciudad', sortable: true },
                    'Acciones'],
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            condicionales: {
                "AND": [
                    {
                        "estado": {
                            "notEquals": "6"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "3"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "2"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "5"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "10"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "5"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "7"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "11"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "9"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "8"
                        }
                    },
                                        {
                        "estado": {
                            "notEquals": "13"
                        }
                    },
                                        {
                        "estado": {
                            "notEquals": "16"
                        }
                    },
                ]
            },
         }
 
     },
     computed: {
       
     },
     async created() {
        
 
     },
     methods: {
      
     }
 };
 </script>
 <style>
 </style>
